import React from "react";
import Reveal from "./Reveal";
import { Award, Calendar, Building2, Car } from "lucide-react";

const STATS = [
  { icon: Calendar, value: "10", unit: "let", label: "na trhu od 2014" },
  { icon: Car, value: "12 000+", unit: "", label: "ošetřených vozidel" },
  { icon: Building2, value: "7", unit: "", label: "B2B dealerských partnerů" },
  { icon: Award, value: "2", unit: "", label: "pobočky · rozšiřujeme" },
];

export const Credentials = () => {
  return (
    <section
      id="proc-nam-veri"
      data-testid="credentials-section"
      className="relative py-16 sm:py-20 md:py-32 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="grid grid-cols-12 gap-y-8 md:gap-10 items-end mb-12 md:mb-16">
          <Reveal className="col-span-12 md:col-span-7">
            <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
              Proč nám věří
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
              Deset let praxe.
              <br />
              <span className="italic text-gold-gradient">Tisíce aut. Jedna úroveň.</span>
            </h2>
          </Reveal>
          <Reveal delay={150} className="col-span-12 md:col-span-5">
            <p className="text-sm sm:text-base text-zinc-400 font-light leading-relaxed">
              CarSpa působí na českém trhu od roku 2014. Svěřují nám vozy značky Škoda, Toyota,
              Volvo, leasingové společnosti i největší bazar v republice. Dnes otevíráme
              stejnou úroveň péče i soukromým klientům — jen do konce května.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-[1px] bg-white/5 border border-white/5">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.label}
                delay={i * 100}
                className="bg-[#060606] p-6 sm:p-8 md:p-10"
              >
                <div data-testid={`credential-stat-${i}`}>
                  <Icon size={26} strokeWidth={1} className="text-[#D4AF37] mb-5 md:mb-6" />
                  <div className="flex items-baseline gap-2">
                    <span className="font-display text-4xl sm:text-5xl md:text-6xl text-white font-light leading-none">
                      {s.value}
                    </span>
                    {s.unit && (
                      <span className="text-sm text-zinc-400">{s.unit}</span>
                    )}
                  </div>
                  <div className="text-[10px] sm:text-[11px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-zinc-500 mt-3 sm:mt-4 leading-relaxed">
                    {s.label}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Credentials;
